import $ from 'jquery';

/**
 * Handle iframe loading
 *
 * @type {DynamicInitFunction<HTMLElement>}
 */
export default ($collection) => {

	for (const iframeWrapper of $collection) {

		try {
			const $iframeWrapper = $(iframeWrapper);
			const {
				url,
				lazy = false,
				loading = true,
				scaleWidth = false,
			} = $iframeWrapper.data('load-iframe') || {};

			if (!url) {
				console.warn('No URL provided for iframe');
				continue;
			}

			const iframe = createIframe(url, lazy);
			if (loading) {
				mpro.addContentLoader($iframeWrapper, ['bg-50']);
				iframe.addEventListener('load', () => {
					mpro.removeContentLoader($iframeWrapper);
				}, { once: true });
			}

			// Get the wrapper height
			const wrapperHeight = $iframeWrapper.height();
			// Get the wrapper border
			// const wrapperBlockBorder = $iframeWrapper.outerHeight() - wrapperHeight;

			// console.log('wrapperHeight', wrapperHeight);
			// console.log('wrapperBlockBorder', wrapperBlockBorder);

			if (scaleWidth) {
				const resizeHandler = () => {

					const wrapperWidth = $iframeWrapper.width();
					// const wrapperInlineBorder = $iframeWrapper.outerWidth() - wrapperWidth;
					const fitContentWidth = wrapperWidth;

					let aspectRatio;
					let targetWidth;
					let targetHeight;

					if (scaleWidth === true) {

						// mpro.getOrientation();
						targetWidth = screen.width;
						targetHeight = screen.height;
						aspectRatio = targetWidth / targetHeight;
					}
					else {
						targetWidth = Number(scaleWidth);
						aspectRatio = targetWidth / screen.height;
						targetHeight = targetWidth / aspectRatio;
					}

					const iframeScale = calculateIframeScale(targetWidth, fitContentWidth);
					targetHeight = wrapperHeight / iframeScale;
					// console.log('targetHeight', targetHeight);

					$iframeWrapper.height(wrapperHeight);
					iframe.style.width = `${targetWidth}px`;
					iframe.style.height = `${targetHeight}px`;
					iframe.style.transform = `scale(${iframeScale})`;
					iframe.style.transformOrigin = '0 0';
					// iframe.style.aspectRatio = `${screen.width} / ${screen.height}`;
				};

				window.addEventListener('resize', resizeHandler, { passive: true });
				resizeHandler();

				$(iframe)
					.one('load', resizeHandler)
					.one('destroy', () => {
						window.removeEventListener('resize', resizeHandler);
					});
			}

			$iframeWrapper.append(iframe);
		}
		catch (error) {
			console.error('Error while loading iframe', error);
		}
	}
};

/**
 * Given a desired width for the iframe, calculate the scale of the iframe
 * so that it fits the desired width while maintaining the aspect ratio
 *
 * @param {Number} scaledIframeWidth
 * @param {Number} fitContentIframeWidth
 */
function calculateIframeScale(scaledIframeWidth, fitContentIframeWidth) {
	return fitContentIframeWidth * 100 / scaledIframeWidth / 100;
}

/**
 * @param {string} url
 * @param {boolean} lazy
 */
function createIframe(url, lazy) {
	const iframe = document.createElement('iframe');
	iframe.src = url;
	iframe.loading = lazy ? 'lazy' : 'eager';
	iframe.referrerPolicy = 'unsafe-url';
	iframe.style.border = '0';
	iframe.style.width = '100%';
	iframe.style.height = '100%';
	iframe.style.verticalAlign = 'middle'; // !! very important !! This is needed to prevent the iframe from being pushed down by the wrapper
	return iframe;
}
